<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      :can-cancel="false"
      :background-color="'transparent'">
    </loading>
    <table width="480" cellpadding="0" border="0" align="center">
      <tbody>
        <tr>
          <td>
            <div class="logoImg" @error="getErrImage"></div>
          </td>
        </tr>
        <tr>
          <td align="center">
            <div v-html="message"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import SiteConstants from 'assets/const/SiteConstants.json';

export default {
    name: 'Mente',
    components: {
        Loading,
    },
    data: function() {
        return {
           menteInit:{
            descriptionInfo:{}
           },
           isLoading: false,
           message: null,
           SiteConstants: SiteConstants
        }
    },
    /*
    * 初期処理
    */
    mounted: function() {
      this.isLoading = true;
      var site = this.$router.history.current.fullPath.split("/")[1];
      if(this.message == null){
        this.$router.push( {name: SiteConstants.PG010MAIN , query: {pageNo: 1}} );
      }
      this.isLoading = false;
    },
    created: function(){
      this.isLoading = true;
      var data = this.$route.params;
      if(data.messageError != null){
        this.message = data.messageError;
      }
      this.isLoading = false;
    }
}
</script>

<style scoped>

</style>

